import useLocalStorage from './useLocalStorage';

export default function useUserToken() {
  const [tokens, setToken] = useLocalStorage('tokens', '');
  return [tokens, setToken];
}
